import React, { useRef, useState } from "react";

import { css, keyframes } from "@emotion/css";
import BodyTypeImg from "../../../img/png/tech/body-type.png";
import BodyTypeDesktopImg from "../../../img/png/tech/body-type-desktop.png";
import BodyTypeLaptopImg from "../../../img/png/tech/body-type-laptop.png";
import BodyTypeTabletImg from "../../../img/png/tech/body-type-tablet.png";
import Item11 from "../../../img/svg/tech/Item11.svg";
import Item12 from "../../../img/svg/tech/Item12.svg";
import Item13 from "../../../img/svg/tech/Item13.svg";
import Item14 from "../../../img/svg/tech/Item14.svg";
import Item21 from "../../../img/svg/tech/Item21.svg";
import Item22 from "../../../img/svg/tech/Item22.svg";
import Item23 from "../../../img/svg/tech/Item23.svg";
import Item24 from "../../../img/svg/tech/Item24.svg";
import Item25 from "../../../img/svg/tech/Item25.svg";
import Item31 from "../../../img/svg/tech/Item31.svg";
import Item32 from "../../../img/svg/tech/Item32.svg";
import Item33 from "../../../img/svg/tech/Item33.svg";
import Item34 from "../../../img/svg/tech/Item34.svg";
import Item35 from "../../../img/svg/tech/Item35.svg";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useMotionValueEvent, useScroll } from "framer-motion";
import { useI18n } from "../../../i18n";

const Results = () => {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const [isActive, setIsActive] = useState(false);

  useMotionValueEvent(
    scrollY,
    "change",
    (latest) => {
      const value =
        (100 * (latest - ref.current.offsetTop)) / ref.current.clientHeight;

      setIsActive(value > 50 ? true : false);
    },
    []
  );

  return (
    <div className={style.container} ref={ref}>
      <div className="overlay"></div>
      <div className="wrapper">
        <div className="title">
          <h3>
            {t("tech_results_in")} <span>{t("tech_results_less10")}</span>{" "}
            {t("tech_results_youll")}
          </h3>
          <h3>{t("tech_results_get")}</h3>
        </div>
        <h2>{t("tech_results_body")}</h2>
        <div className="body-type-image"></div>
        <p>
          {t("tech_results_body_body")}
        </p>
        <div className={`items ${isActive ? "" : "inactive"}`}>
          <div className="item i1">
            <img src={Item11} alt={t("tech_result_1")} className="i11" />
            <img src={Item12} alt={t("tech_result_2")} className="i12" />
            <img src={Item13} alt={t("tech_result_3")} className="i13" />
            <img src={Item14} alt={t("tech_result_4")} className="i14" />
          </div>
          <div className="item i2">
            <img src={Item21} alt={t("tech_result_5")} className="i21" />
            <img src={Item22} alt={t("tech_result_6")} className="i22" />
            <img src={Item23} alt={t("tech_result_7")} className="i23" />
            <img src={Item24} alt={t("tech_result_8")} className="i24" />
            <img src={Item25} alt={t("tech_result_9")} className="i25" />
          </div>
          <div className="item i3">
            <img src={Item31} alt={t("tech_result_10")} className="i31" />
            <img src={Item32} alt={t("tech_result_11")} className="i32" />
            <img src={Item33} alt={t("tech_result_12")} className="i33" />
            <img src={Item34} alt={t("tech_result_13")} className="i34" />
            <img src={Item35} alt={t("tech_result_14")} className="i35" />
          </div>
        </div>
      </div>
    </div>
  );
};

const bounce = (bounce = 15, reverse = false) =>
  keyframes({
    "0%": {
      transform: `translateY(0px)`,
    },
    "40%": {
      transform: `translateY(${reverse ? "-" : ""}${bounce}px)`,
    },
    "100%": {
      transform: `translateY(0px)`,
    },
  });

const style = {
  container: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: "auto",
    backgroundColor: "#fff",
    height: "100%",
    position: "relative",
    overflow: "hidden",

    ".overlay": {
      background:
        "linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.20) 12.8%, #6643FF 97.86%)",
      height: 1544,
      width: "100%",
      left: 0,
      top: 0,
      position: "absolute",
      zIndex: 1,
    },
    ".wrapper": {
      zIndex: 1,
      position: "relative",
      maxWidth: 1400,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    ".title": {
      marginTop: 157,
      width: "100%",
    },
    ".body-type-image": {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      backgroundSize: "contain",
      backgroundImage: `url(${BodyTypeImg})`,
      width: 1279,
      height: 1236,
      marginTop: "-280px",
      zIndex: 1,
      position: "relative",
    },
    ".items": {
      marginTop: 90,
      marginBottom: 65,
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",

      "&.inactive": {
        ".item": {
          img: {
            transitionDelay: "0s !important",
            animationName: "unset !important",
            top: "-100% !important",
          },
        },
      },

      ".item": {
        borderRadius: 100,
        width: 409,
        height: 234,
        overflow: "hidden",
        position: "relative",
        background:
          "linear-gradient(0deg, #E0DDEC 0%, #E0DDEC 100%), linear-gradient(156deg, #FFF -10.59%, rgba(255, 255, 255, 0.20) 2.61%, #013DFF 90.31%), #FFF",

        img: {
          transition: "all 2s",
          position: "absolute",
          animationDelay: "1s",
          animationDuration: "2s",
          animationName: `${bounce()}`,
        },

        "&.i2": {
          img: {
            animationDelay: "2s",
            transitionDelay: "1s",
          },
        },
        "&.i3": {
          img: {
            animationDelay: "3s",
            transitionDelay: "2s",
          },
        },

        ".i11": {
          top: "12%",
          left: "7%",
        },

        ".i12": {
          top: "30%",
          right: "7%",
        },

        ".i13": {
          top: "50%",
          right: "7%",
        },

        ".i14": {
          top: "73%",
          right: "17%",
        },

        ".i21": {
          top: "15%",
          left: "13%",
        },

        ".i22": {
          top: "30%",
          right: "14%",
        },

        ".i23": {
          top: "40%",
          left: "7%",
        },

        ".i24": {
          top: "65%",
          right: "17%",
        },

        ".i25": {
          top: "50%",
          right: "7%",
        },

        ".i31": {
          top: "65%",
          right: "5%",
        },

        ".i32": {
          top: "55%",
          left: "7%",
        },

        ".i33": {
          top: "35%",
          right: "2%",
        },

        ".i34": {
          top: "40%",
          left: "2%",
        },

        ".i35": {
          top: "10%",
          left: "7%",
        },
      },
    },
    p: {
      color: "#000",
      textAlign: "center",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
      maxWidth: 704,
    },
    h2: {
      color: "#000",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 120,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "140px",
      textTransform: "uppercase",
      marginTop: 100,
    },
    h3: {
      color: "#FFF",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 82,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "39.4px",
      display: "flex",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 14,
      marginBottom: 48,

      span: {
        borderRadius: 105.438,
        background: "#6643FF",
        boxShadow: "4.563px 6.084px 0px 0px #462EE9",
        display: "flex",
        transform: "rotate(3deg)",
        padding: "15.816px 31.631px",
        justifyContent: "center",
        alignItems: "center",
        gap: 5.272,
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 64,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "39.4px",
        width: 420,
      },
    },
    [desktop]: {
      ".overlay": {
        height: 1655,
      },
      ".wrapper": {
        maxWidth: 1026,
      },
      ".title": {
        marginTop: 157,
        width: "100%",
      },
      ".body-type-image": {
        backgroundImage: `url(${BodyTypeDesktopImg})`,
        width: 1024,
        height: 1453,
        marginTop: "80px",
        zIndex: 1,
        position: "relative",
      },
      ".items": {
        marginTop: 90,
        marginBottom: 60,

        ".item": {
          width: 292,
          height: 167,
          borderRadius: 71.473,

          img: {
            transform: "scale(0.75) !important ",
          },

          ".i11": {
            top: "5%",
            left: "7%",
          },

          ".i12": {
            top: "25%",
            right: "7%",
          },

          ".i13": {
            top: "47%",
            right: "-10%",
          },

          ".i14": {
            top: "73%",
            right: "17%",
          },

          ".i21": {
            top: "5%",
            left: "13%",
          },

          ".i22": {
            top: "25%",
            right: "14%",
          },

          ".i23": {
            top: "35%",
            left: "1%",
          },

          ".i24": {
            top: "66%",
            right: "7%",
          },

          ".i25": {
            top: "50%",
            right: "7%",
          },

          ".i31": {
            top: "75%",
            right: "5%",
          },

          ".i32": {
            top: "40%",
            left: "0%",
          },

          ".i33": {
            top: "30%",
            right: "-7%",
          },

          ".i34": {
            top: "26%",
            left: "-5%",
          },

          ".i35": {
            top: "0%",
            left: "7%",
          },
        },
      },
      p: {
        fontSize: 18,
        letterSpacing: 0.36,
        marginTop: -140,
      },
      h2: {
        fontSize: 90,
        lineHeight: "87px",
        marginTop: 110,
      },
      h3: {
        fontSize: 64,
        lineHeight: "40px",
        gap: 14,
        marginBottom: 28,

        span: {
          fontSize: 54,
          lineHeight: "40px",
          width: 410,
        },
      },
    },
    [laptop]: {
      ".overlay": {
        height: 1544,
      },
      ".wrapper": {
        maxWidth: 1026,
      },
      ".title": {
        marginTop: 157,
        width: "100%",
      },
      ".body-type-image": {
        backgroundImage: `url(${BodyTypeLaptopImg})`,
        width: 744,
        height: 961,
        marginTop: "80px",
        zIndex: 1,
        position: "relative",
      },
      ".items": {
        marginTop: 80,
        marginBottom: 80,

        ".item": {
          width: 250,
          height: 128,
          borderRadius: 71.473,

          img: {
            transform: "scale(0.60) !important ",
          },

          ".i11": {
            top: "2%",
            left: "7%",
          },

          ".i12": {
            top: "22%",
            right: "7%",
          },

          ".i13": {
            top: "44%",
            right: "-15%",
          },

          ".i14": {
            top: "73%",
            right: "17%",
          },

          ".i21": {
            top: "2%",
            left: "13%",
          },

          ".i22": {
            top: "22%",
            right: "14%",
          },

          ".i23": {
            top: "32%",
            left: "-5%",
          },

          ".i24": {
            top: "60%",
            right: "7%",
          },

          ".i25": {
            top: "47%",
            right: "7%",
          },

          ".i31": {
            top: "72%",
            right: "5%",
          },

          ".i32": {
            top: "37%",
            left: "0%",
          },

          ".i33": {
            top: "27%",
            right: "-7%",
          },

          ".i34": {
            top: "23%",
            left: "-5%",
          },

          ".i35": {
            top: "-3%",
            left: "7%",
          },
        },
      },
      p: {
        fontSize: 16,
        letterSpacing: 0.32,
        marginTop: 40,
        maxWidth: 500,
      },
      h2: {
        fontSize: 60,
        lineHeight: "62px",
        marginTop: 90,
        maxWidth: 700,
      },
      h3: {
        fontSize: 52,
        lineHeight: "40px",
        gap: 12,
        marginBottom: 22,

        span: {
          fontSize: 40,
          lineHeight: "40px",
          width: 318,
        },
      },
    },
    [tablet]: {
      ".overlay": {
        height: 1180,
      },
      ".wrapper": {
        maxWidth: 1026,
      },
      ".title": {
        marginTop: 50,
        width: "100%",
      },
      ".body-type-image": {
        backgroundImage: `url(${BodyTypeTabletImg})`,
        width: 375,
        height: 518,
        marginTop: "0px",
      },
      ".items": {
        marginTop: 37,
        marginBottom: 40,
        gap: 17,
        flexDirection: "column",

        ".item": {
          width: 338,
          height: 172,
          borderRadius: 73.799,

          img: {
            transform: "scale(0.85) !important ",
          },
          ".i11": {
            top: "5%",
            left: "7%",
          },

          ".i12": {
            top: "25%",
            right: "7%",
          },

          ".i13": {
            top: "47%",
            right: "-10%",
          },

          ".i14": {
            top: "73%",
            right: "17%",
          },

          ".i21": {
            top: "5%",
            left: "13%",
          },

          ".i22": {
            top: "25%",
            right: "14%",
          },

          ".i23": {
            top: "35%",
            left: "1%",
          },

          ".i24": {
            top: "66%",
            right: "7%",
          },

          ".i25": {
            top: "50%",
            right: "7%",
          },

          ".i31": {
            top: "75%",
            right: "5%",
          },

          ".i32": {
            top: "40%",
            left: "0%",
          },

          ".i33": {
            top: "30%",
            right: "-7%",
          },

          ".i34": {
            top: "26%",
            left: "-5%",
          },

          ".i35": {
            top: "0%",
            left: "7%",
          },
        },
      },
      p: {
        fontSize: 14,
        letterSpacing: 0.28,
        marginTop: 40,
        maxWidth: 334,
      },
      h2: {
        fontSize: 32,
        lineHeight: "38px",
        marginTop: 51,
        maxWidth: 355,
      },
      h3: {
        fontSize: 26,
        lineHeight: "30px",
        gap: 10,
        marginBottom: 22,

        span: {
          fontSize: 22,
          lineHeight: "32px",
          padding: "10.735px 21.47px",
          width: 182,
        },
      },
    },
  }),
};

export default Results;
